import type { AvvirEvent } from "type_aliases";

export type OrganizationMemberRemovedEvent = AvvirEvent<typeof ORGANIZATION_MEMBER_REMOVED, {
  firebaseOrganizationId: string,
  memberId: number
}>

export const organizationMemberRemoved = (firebaseOrganizationId: string, memberId: number): OrganizationMemberRemovedEvent => ({
  type: ORGANIZATION_MEMBER_REMOVED,
  payload: {
    firebaseOrganizationId,
    memberId
  }
});

export const ORGANIZATION_MEMBER_REMOVED = "organization_member_removed";